function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#010101}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"
});

const SvgIosClose = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-close.0cbf6b04.svg";
export { ForwardRef as ReactComponent };